/* eslint-disable jira/filename-case */
declare global {
	interface Window {
		__SSR_FALLBACK__?: boolean;
	}
}

/*
 * This function only supports detecting sucess for Modern SSR
 */
export function didSSRSucceed(): boolean {
	const traceData = globalThis.window?.SPA_STATE?.['ssr/detail_request_trace']?.data;
	if (!traceData) {
		return false;
	}
	const prefetchTimedOut = Object.values(
		// oxlint-disable-next-line typescript/consistent-type-assertions
		traceData as {
			[key: string]: {
				startTime?: number;
				duration?: number;
				failureReason?: string;
			};
		},
	).some((x) => x.failureReason === 'timeout');
	return (
		!prefetchTimedOut &&
		// Static fallback is returned when there is the 2.7s timeout of SSR
		!globalThis.window.__SSR_FALLBACK__
	);
}
